import * as Yup from "yup";

export const courtVoiceSchema = Yup.object().shape({
  name: Yup.string().required("Court name is required"),
});
